module.exports = __webpack_public_path__ + "img/delete.3186448e.svg";